import React from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "../../utils/comman/Dashboard.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { GrUpdate } from "react-icons/gr";
import { FcCallback } from "react-icons/fc";
import { RiCustomerService2Fill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import { useEffect } from "react";
import TooltipLite from "react-tooltip-lite";
import { useSelector } from "react-redux/es/exports";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid4 } from "uuid";
import {
  copyTextToClipboard,
  dangerColor,
  formatNumberForIndia,
  isSuperAdmin,
  isUserAdmin,
  primaryColor,
  stylesofStype,
  utrLeng,
} from "../../utils/comman/Common";
import { Tooltip } from "react-tooltip";
import {
  REQID,
  TXNID,
  setpageContent,
  UTR,
  VPA,
  ODRCODE,
  Statusoptions,
  searchbyOptions,
  AMOUNT,
  isSuccess,
  applyReversed,
  isActualSuccessStatus,
} from "../../utils/Constant";
import StatusDetails from "../../utils/comman/statusDetails";

import Addticket from "../Model/AddTicket";
import moment from "moment";
import SearchBar from "./Search";
import { appVersion } from "../../version";
import UpdateUtrAspaymentpage from "../Model/UpdateUtrAspaymentpage";

const UpiHome = () => {
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));

  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [filterupdatedOn, setFilterupdatedOn] = useState(true);
  const [statusOption, setStatusOption] = useState(Statusoptions);
  const [showTicketDropdown, setShowTicketDropdown] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [ticketLists, setTicketLists] = useState(null);
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  //statusDate\
  const [isStatusFilter, setIsStatusFilter] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [statusDate, setStatusDate] = useState(today);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);

  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [dataForUpdateUtr, setDataForUpdateUtr] = useState({});
  const [showUpdateUtrOnly, setShowUpdateUtronly] = useState(false);
  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([
      {
        id: "SUCCESS",
        count: 0,
        total: 0,
      },
      {
        id: "PENDING",
        count: 0,
        total: 0,
      },
      {
        id: "FAILED",
        count: 0,
        total: 0,
      },
    ]);
  console.log("dataForUpdateUtr", dataForUpdateUtr);
  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState(searchbyOptions);
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const [selectedTraxn, setSelectedTraxn] = useState(null);
  const [attachmentId, setattachmentId] = useState(null);
  const [isCalledSatausApi, setIsCalledSatausApi] = useState(false);
  const [iconLoader, setIconLoader] = useState({ loader: false, id: null });
  const [show, setShow] = useState(false);
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const [selectedTicket, setselectedTicket] = useState();
  const [isAllTicketResolved, setIsAllTicketResolved] = useState(true);
  const [toAmount, setToAmount] = useState(null);
  const [fromAmount, setFromAmount] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const url = process.env.REACT_APP_HISTORY;
  const toggleDropdown = (e) => {
    console.log("Filter toggle clicked");
    e.stopPropagation();
    setIsDropdownOpen((prevState) => !prevState);
  };
  var request = {
    mid: mid,
    requestId: "",
    orderCode: "",
    txnId: "",
    utr: "",
    vpa: "",
    useUpdatedOn: filterupdatedOn,
    fromAmt: null,
    toAmt: null,
    fromDate: null,
    toDate: null,
    statusList: [],
    pageNum: 0,
    perPage: paginationDetails.postsPerPage,
  };
  console.log("selectedStatus1", selectedStatus);
  const finalStatus =
    Array.isArray(selectedStatus) && selectedStatus.length > 0
      ? selectedStatus.map((item) => item.value)
      : [];
  const INTIAL_VALUE = {
    merchantId: "",
    type: "PAY_IN",
    txnId: "",
    createdBy: profileInfo?.id,
    description: "",
    userUtr: "",
    userTxnDate: "",
    comments: null,
    attachmentId: "",
  };
  const [ticketRequest, setticketRequest] = useState(INTIAL_VALUE);

  const [attachedFile, setAttechedFile] = useState(null);
  const getUniqId = () => {
    const uuid = uuid4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);
  const increaseOneDate = (date) => {
    console.log("datedate", date);
    if (date !== undefined && date !== null && date !== "") {
      return moment(date).add(1, "day").format("YYYY-MM-DD");
    } else {
      return null;
    }
  };
  const checkstatus = (status) => {
    if (status === "SUCCESS_AUTO") {
      return false;
    } else if (status === "SUCCESS_MANUAL") {
      return false;
    } else {
      return true;
    }
  };
  const uploadFile = async (files) => {
    if (!files) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", files);
      const url = "/api/v1/upi/file/upload/1209600";
      const response = await axiosInstance.post(url, formData, { headers });

      if (response.status == 200 && response.data?.id !== undefined) {
        console.log("File uploaded successfully", response.data);
        // Optionally handle response data
        toast.success("File has added");
        setattachmentId(response.data);
        return response;
      } else {
        toast.error(
          "unable to upload image and file permitted size is 1048576 bytes"
        );
        console.error("Failed to upload file");
      }
    } catch (error) {
      toast.error("Error uploading file:", error);
      console.error("Error uploading file:", error);
    }
  };

  function validateUTR(utr) {
    // Check if UTR is exactly 12 digits
    if (!/^\d{12}$/.test(utr)) {
      return false;
    }

    // Get the last digit of the current year
    const currentYearLastDigit = new Date().getFullYear().toString().slice(-1);

    // Get the last two digits of the previous year
    const previousYearLastTwoDigits = (new Date().getFullYear() - 1)
      .toString()
      .slice(-2);

    // Get the current month and day
    const currentMonth = new Date().getMonth() + 1; // Add 1 to get the month number (January is 1, December is 12)
    const currentDay = new Date().getDate();

    // Check if today is January 1st and the UTR corresponds to December 31st of the previous year
    if (currentMonth === 1 && currentDay === 1) {
      // customLog("utr", utr);
      // customLog(utr[0], previousYearLastTwoDigits[1]);
      if (utr[0] === previousYearLastTwoDigits[1]) {
        return true;
      }
    }

    // Check if the first digit of the UTR matches the last digit of the current year
    if (utr[0] !== currentYearLastDigit) {
      return false;
    }

    return true;
  }
  // const handleClose = () => {}
  const handleClose = () => {
    setShow(false);
    setTicketLists(null);
    setticketRequest(INTIAL_VALUE);
    setShowTicketDropdown(false);
    setselectedTicket();
    setIsAllTicketResolved(true);
  };
  //setIsAllTicketResolved
  const handleShow = () => {
    setShow(true);
    setTicketLists(null);
    setticketRequest(INTIAL_VALUE);
    setShowTicketDropdown(false);
    setselectedTicket();
    setIsAllTicketResolved(true);
  };
  function isNumeric(num) {
    return !isNaN(num);
  }
  // const handleShow = () => setShow(true);
  useEffect(() => {
    setSearchedByItemShow(true);
    setSearchedBy();
    if (search.length > 0 && !isNumeric(search)) {
      const notNumericSearch = searchedByItem.filter(
        (val) => val !== AMOUNT && val !== UTR
      );
      setSearchedByItem(notNumericSearch);
    } else if (search.length > 0 && isNumeric(search)) {
      setSearchedByItem(searchbyOptions);
    }
  }, [search]);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);

  const handalpageclick = async (index) => {
    request["fromDate"] = isStatusFilter ? statusDate : formDate;
    request["toDate"] = isStatusFilter
      ? increaseOneDate(statusDate)
      : increaseOneDate(toDate);
    request["statusList"] = finalStatus;
    request["pageNum"] = index - 1;
    request["perPage"] = paginationDetails.postsPerPage;
    if (searchedBy == REQID) {
      request.requestId = search;
    } else if (searchedBy == TXNID) {
      request.txnId = search;
    } else if (searchedBy == ODRCODE) {
      request.orderCode = search;
    } else if (searchedBy == UTR) {
      request.utr = search;
    } else if (searchedBy == VPA) {
      request.vpa = search;
    } else if (searchedBy == AMOUNT) {
      request.toAmt = parseInt(search);
      request.fromAmt = parseInt(search);
    }
    if (url && request) {
      callApis(url, request);
    }
    console.log("req", isStatusFilter, request);
    if (url && request) {
      callApis(url, request);
      setPaginationDetails((prev) => {
        return { ...prev, currentPage: index };
      });
    }
  };
  const fromAmountHandler = (e) => {
    const { value } = e.target;
    if (isNumeric(value)) {
      setFromAmount(value);
    }
  };
  const toAmountHandler = (e) => {
    const { value } = e.target;
    if (isNumeric(value)) {
      setToAmount(value);
    }
  };
  const searchdata = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      // setRetailerList([])
    }

    if (event.target.value !== "") {
      const trimSearch = event.target.value.trim();
      setSearched({
        name: trimSearch,
        typing: true,
        typingTimeout: setTimeout(function () {
          // sendToParent(searched.name);
          if (event.target.value) {
            setSearchTyping(true);
            setsearch(trimSearch);
          } else {
          }
        }, 500),
      });
    } else {
      setsearch(event.target.value);
      setSearched({
        typing: false,
      });
    }
  };
  const addTimeTodate = (date) => {
    const nextDay = moment(date).add(1, "day").format("YYYY-MM-DD");
    return `${nextDay}T00:00:00`;
  };
  const addTimeFromdate = (date) => {
    return `${date}T00:00:00`;
  };
  useEffect(() => {
    const finalStatus = selectedStatus.map((item) => item.value);
    const url = process.env.REACT_APP_HISTORY;

    request["fromDate"] = formDate;
    request["toDate"] = toDate;
    request["statusList"] = finalStatus;
    request["pageNum"] = paginationDetails.currentPage - 1;
    request["perPage"] = paginationDetails.postsPerPage;
    if (url && request) {
      callApis(url, request);
    }
  }, []);

  const callStatus = async (values) => {
    const finalStatus = await values.map((item) => item.value);
    const url = process.env.REACT_APP_HISTORY;
    request["fromDate"] = statusDate;
    request["toDate"] = increaseOneDate(statusDate);
    request["statusList"] = finalStatus;
    request["pageNum"] = 0;
    request["perPage"] = paginationDetails.postsPerPage;

    if (url && request) {
      callApis(url, request);
    }
  };
  useEffect(() => {
    const finalStatus = selectedStatus.map((item) => item.value);
    const url = process.env.REACT_APP_HISTORY;

    request["fromDate"] = statusDate;
    request["toDate"] = increaseOneDate(statusDate);
    request["statusList"] = finalStatus;
    request["pageNum"] = 0;
    request["perPage"] = paginationDetails.postsPerPage;
    if (url && request && isCalledSatausApi) {
      callApis(url, request);
    }
  }, [statusDate]);

  useEffect(() => {
    if (statusDate !== null) {
      getStatus();
    }
  }, [statusDate]);
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  async function callApis(url, request) {
    await fetchpagedata(url, request);
  }
  const fetchpagedata = async (url, request) => {
    setDataLoading(true);
    try {
      const res = await axiosInstance.post(url, request, { headers });

      if (res.status === 200 && res?.data?.transactions !== undefined) {
        settable(res.data.transactions);
        setBackupTableData(res.data);
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            currentPage: res.data?.pageNum + 1,
            totalPost: res.data?.totalCount,
            totalPages: res.data?.pages,
          };
        });
      } else {
        console.log("res====>", res);
        throw new Error(res?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      setIsDataLoaded(false);
      console.error("Error", error);

      toast.error(error?.message);
      return false;
    }
  };

  // const getStatus = async () => {
  //   const url = `/api/v1/upi/reporting/mis/payin?date=${statusDate}&mid=${mid}`;
  //   setDataLoading(true);
  //   const response = await axiosInstance
  //     .get(url, { headers })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         console.log("res", res);
  //         let successCounts = 0;
  //         let failedCounts = 0;
  //         let pendingCounts = 0;
  //         let successAmount = 0;
  //         let failedAmount = 0;
  //         let pendingAmount = 0;
  //         setDataLoading(false);
  //         let values = res.data;
  //         values.forEach((status) => {
  //           if (status.id.startsWith("SUCCESS")) {
  //             successCounts += status.count;
  //             successAmount += parseInt(status?.processedAmount);
  //           } else if (
  //             status.id === "FAILED" ||
  //             status.id === "REVERSED" ||
  //             status.id === "SYS_ERROR" ||
  //             status.id === "CANCELED" ||
  //             status.id === "UNPROCESSED"
  //           ) {
  //             failedCounts += status.count;
  //             failedAmount += parseInt(status.amount);
  //           } else {
  //             pendingCounts += status.count;
  //             pendingAmount += parseInt(status.amount);
  //           }
  //         });

  //         // Create object of arrays
  //         const result = [
  //           {
  //             id: "SUCCESS",
  //             amount: successAmount,
  //             count: successCounts,
  //           },
  //           {
  //             id: "FAILED",
  //             amount: failedAmount,
  //             count: failedCounts,
  //           },
  //           {
  //             id: "PENDING",
  //             amount: pendingAmount,
  //             count: pendingCounts,
  //           },
  //         ];

  //         // console.log('result', result);
  //         // console.log('values', values)
  //         setTransactionStatuswithAmount(result);
  //       } else if (res?.response?.data?.message !== undefined) {
  //         throw new Error(res?.response?.data?.message);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setDataLoading(false);
  //       setIsDataLoaded(false);
  //       toast.error(err?.message);
  //       // toast.error("Something went wrong");
  //     });

  //   if (response) {
  //     const result = response.data.orders;

  //     if (result) {
  //     }

  //     return response.data;
  //   }
  //   return false;
  // };

  const getStatus = async () => {
    let url =
      mid !== null && mid !== undefined
        ? `/api/v1/upi/reporting/mis/payin`
        : `/api/v1/upi/reporting/mis/payin`;

    let request = {
      date: statusDate,
      endDate: null,
      mid: mid !== null && mid !== undefined && mid ? mid : "",
      midList: [],
      type: "",
      vpaList: [],
      txnType: ["UPI", "FUND_TRANSFER"],
      splitByAccount: false,
      splitByMid: false,
    };

    url = url + `?user=${id}`;
    setDataLoading(true);
    const response = await axiosInstance
      .post(url, request, { headers })
      .then((res) => {
        // console.log("res", res);
        let successCounts = 0;
        let failedCounts = 0;
        let pendingCounts = 0;
        let successAmount = 0;
        let failedAmount = 0;
        let pendingAmount = 0;
        setDataLoading(false);
        let values = res.data;

        values.forEach((status) => {
          if (isActualSuccessStatus(status.id)) {
            successCounts += status.count;
            successAmount += parseInt(status.processedAmount);
            return;
          } else if (
            status.id === "FAILED" ||
            status.id === "REVERSED" ||
            status.id === "SYS_ERROR" ||
            status.id === "CANCELED" ||
            status.id === "UNPROCESSED"
          ) {
            failedCounts += status.count;
            failedAmount += parseInt(status.amount);
            return;
          } else {
            pendingCounts += status.count;
            pendingAmount += parseInt(status.amount);
            return;
          }
        });

        // Create object of arrays
        const result = [
          {
            id: "SUCCESS",
            amount: successAmount,
            count: successCounts,
          },
          {
            id: "FAILED",
            amount: failedAmount,
            count: failedCounts,
          },
          {
            id: "PENDING",
            amount: pendingAmount,
            count: pendingCounts,
          },
        ];

        // console.log('result', result);
        // console.log('values', values)
        setTransactionStatuswithAmount(result);
      })
      .catch((err) => {
        console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  useEffect(() => {
    const finalStatus = selectedStatus.map((item) => item.value);
    var url = process.env.REACT_APP_HISTORY;
    request["fromDate"] = formDate;
    request["toDate"] = toDate;
    request["statusList"] = finalStatus;
    request["pageNum"] = paginationDetails.currentPage - 1;
    request["perPage"] = paginationDetails.postsPerPage;
    if (search.length > 0) {
      if (searchedBy == REQID) {
        request.requestId = search;
        callApis(url, request);
      } else if (searchedBy == TXNID) {
        request.txnId = search;
        callApis(url, request);
      } else if (searchedBy == ODRCODE) {
        request.orderCode = search;
        callApis(url, request);
      } else if (searchedBy == UTR) {
        request.utr = search;
        callApis(url, request);
      } else if (searchedBy == VPA) {
        request.vpa = search;
        callApis(url, request);
      } else if (searchedBy == AMOUNT) {
        request.toAmt = parseInt(search);
        request.fromAmt = parseInt(search);
        if (isNumeric(search)) {
          setFromAmount(search);
        }
        if (isNumeric(search)) {
          setToAmount(search);
        }
        callApis(url, request);
      }
    }
  }, [searchedBy]);

  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    setIsDropdownOpen(false);
    const finalStatus = selectedStatus.map((item) => item.value);
    const url = process.env.REACT_APP_HISTORY;
    const request = {
      mid: mid,
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      useUpdatedOn: filterupdatedOn,
      fromDate: formDate,
      toDate: toDate,
      statusList: finalStatus,
      pageNum: paginationDetails.currentPage - 1,
      perPage: paginationDetails.postsPerPage,
    };
    if (searchedBy == REQID) {
      request.requestId = search;
    } else if (searchedBy == TXNID) {
      request.txnId = search;
    } else if (searchedBy == ODRCODE) {
      request.orderCode = search;
    } else if (searchedBy == UTR) {
      request.utr = search;
    } else if (searchedBy == VPA) {
      request.vpa = search;
    }
    if (parseFloat(fromAmount) > parseFloat(toAmount)) {
      toast.warn(
        "To amount should always be greater than or equal to from amount"
      );
      return;
    }
    if (fromAmount !== null && fromAmount !== "") {
      request.fromAmt = parseInt(fromAmount);
    }
    if (toAmount !== null && toAmount !== "") {
      request.toAmt = parseInt(toAmount);
    }
    if (url && request) {
      callApis(url, request);
    }
  };
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };
  const convertToXLSX = (data, fileName) => {
    const parsedData = Papa.parse(data, { header: true });
    const worksheet = XLSX.utils.json_to_sheet(parsedData.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };
  const onExportData = async () => {
    const expFileLength = 10000;
    const request = {
      mid: mid,
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      useUpdatedOn: filterupdatedOn,
      fromDate:
        formDate !== undefined && formDate !== null && formDate !== ""
          ? addTimeFromdate(formDate)
          : null,
      toDate:
        toDate !== undefined && toDate !== null && toDate !== ""
          ? addTimeTodate(toDate)
          : null,
      statusList: finalStatus,
      pageNum: 0,
      perPage: expFileLength,
    };
    if (searchedBy == REQID) {
      request.requestId = search;
    } else if (searchedBy == TXNID) {
      request.txnId = search;
    } else if (searchedBy == ODRCODE) {
      request.orderCode = search;
    } else if (searchedBy == UTR) {
      request.utr = search;
    } else if (searchedBy == VPA) {
      request.vpa = search;
    }
    const fetchExportdata = async (url, request) => {
      setDataLoading(true);
      const response = await axiosInstance
        .post(url, request, { headers })
        .then((res) => {
          setDataLoading(false);
          setIsDataLoaded(false);
          const fileName = `${getUniqId()}_${getCurrentDateTime()}`;
          convertToXLSX(res?.data, fileName);
        })
        .catch((err) => {
          console.log(err);
          setDataLoading(false);
          setIsDataLoaded(false);
          // toast.error("Something went wrong");
        });

      if (response) {
        return response.data;
      }
      return false;
    };
    const url = "/api/v1/upi/q/payin/report";

    if (url && request) {
      const fileExport = await fetchExportdata(url, request, { headers });
    }
  };

  const resetApply = () => {
    setFinalSelectedStatus([]);
    setSelectedStatus([]);
    setIsDropdownOpen(false);
    setIsExportable(false);
    //setFilterupdatedOn(false);
    setFormDate("");
    setToDate("");
    setFromAmount("");
    setToAmount("");
    setSearched({
      name: "",
      typing: false,
      typingTimeout: setTimeout(function () {
        setSearchTyping(false);
        setsearch("");
      }, 100),
    });
    // const url = process.env.REACT_APP_HISTORY;

    if (url && request) {
      callApis(url, request);
    }
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };

  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    } else if (fromAmount !== "" && fromAmount !== null) {
      disabled = false;
    } else if (toAmount !== "" && toAmount !== null) {
      disabled = false;
    } else if (filterupdatedOn) {
      disabled = false;
    }
    return disabled;
  };
  const ticketChangeHandle = (e) => {
    const { name, value } = e.target;
    //console.log("validateUTR(value)", validateUTR(value));
    if (name == "userUtr") {
      const sanitizedValue = value.replace(/\D/g, "").substring(0, 12);
      setticketRequest({
        ...ticketRequest,
        userUtr: sanitizedValue,
      });
      return;
    }

    if (name !== "userUtr") {
      setticketRequest((pre) => ({ ...pre, [name]: value }));
    }
  };
  const reloadTxn = () => {
    const url = process.env.REACT_APP_HISTORY;

    request["fromDate"] = null;
    request["toDate"] = null;
    request["statusList"] = [];
    request["pageNum"] = 0;
    request["perPage"] = paginationDetails.postsPerPage;
    if (url && request) {
      callApis(url, request);
      setFormDate("");
      setToDate("");
      setFromAmount("");
      setToAmount("");
      // setFilterupdatedOn(false);
      setSelectedStatus([]);
      setIsCalledSatausApi(false);
      setStatusDate(today);
      setIsStatusFilter(false);
    }
  };
  const statusFilterHandler = (data) => {
    console.log("data", data);
    //status.id.startsWith("SUCCESS")
    setFormDate(statusDate);
    setToDate(increaseOneDate(statusDate));
    let result = [];
    if (data == "SUCCESS") {
      result = Statusoptions.filter((option) => option.value.startsWith(data));
      callStatus(result);
      setSelectedStatus(result);
      setIsStatusFilter(true);
    } else if (data == "FAILED") {
      const includeValues = [
        "FAILED",
        "CANCELED",
        "SYS_ERROR",
        "REVERSED",
        "UNPROCESSED",
      ];
      result = Statusoptions.filter((option) =>
        includeValues.some((val) => option.value.startsWith(val))
      );
      // result = Statusoptions.filter((option) => option.value == data);
      console.log("result", result);
      callStatus(result);
      setSelectedStatus(result);
      setIsStatusFilter(true);
    } else {
      const excludedValues = [
        "SUCCESS",
        "FAILED",
        "CANCELED",
        "SYS_ERROR",
        "REVERSED",
        "UNPROCESSED",
      ];
      result = Statusoptions.filter(
        (option) => !excludedValues.some((val) => option.value.startsWith(val))
      );
      console.log("result", result, Statusoptions);
      callStatus(result);
      setSelectedStatus(result);
      setIsStatusFilter(true);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const res = await uploadFile(file);
  };

  const createNewTicket = async (e) => {
    e.preventDefault();
    const requestPayload = {
      ...ticketRequest,
      merchantId: selectedTraxn?.merchantId,
      txnId: selectedTraxn?.id,
      attachmentId: attachmentId?.id,
    };
    console.log(
      "ticketRequest?.userUtr",
      ticketRequest?.userUtr,
      requestPayload
    );
    if (!validateUTR(ticketRequest?.userUtr)) {
      toast.error("Utr is not valid");
      return;
    }

    if (requestPayload?.merchantId == "") {
      toast.error("merchantId is not Correct and its required to fill");
      return;
    }
    if (requestPayload?.type == "") {
      toast.error("type is not Valid and its required to fill");
      return;
    }
    if (requestPayload?.createdBy == "") {
      toast.error("Created By is not Valid and its required to fill");
      return;
    }
    if (requestPayload?.description == "") {
      toast.error("Description By is not Correct and its required to fill");
      return;
    }
    //userTxnDate
    if (requestPayload?.userTxnDate == "") {
      toast.error("User Txn Date By is not Valid and its required to fill");
      return;
    }
    if (requestPayload?.userTxnDate == "") {
      toast.error("User Txn Date By is not Valid and its required to fill");
      return;
    }

    setDataLoading(true);
    const API_ENDPOINT = "/api/v1/upi/ticket/create";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.id !== undefined) {
        toast.success(
          `Your ticket has raised and ref is ${response?.data?.id}`
        );
        setticketRequest(INTIAL_VALUE);
        setDataLoading(false);
        handleClose();
      } else {
        setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  const handleCallBack = async (e, data) => {
    e.preventDefault();
    setIconLoader({ loader: true, id: data?.id });
    const API_ENDPOINT = `/api/v1/upi/payin/merchant/callback/${data?.id}`;
    try {
      const requestPayload = {};

      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });
      setIconLoader({ loader: false, id: null });
      if (response.status === 200 && response?.data?.txnId !== undefined) {
        toast.success("Callback request registered");
      } else if (
        response.status === 200 &&
        response?.data?.status !== "SYS_ERROR"
      ) {
        const msg = response?.response?.msg;
        toast.error(msg);
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  //editPlans
  const selectedTranxtForIssue = (e, data) => {
    e.preventDefault();
    setticketRequest((pre) => ({
      ...pre,
      userUtr: data?.userEnteredUtr !== undefined ? data?.userEnteredUtr : "",
    }));
    setSelectedTraxn(data);
    handleShow();
  };
  const clearSearchData = () => {
    console.log("clearSearchData");
    setsearch("");
    setSearchedBy();
    setSearched({ name: "", typing: false, typingTimeout: 0 });
    resetApply();
    setDataLoading(false);
    setIsDataLoaded(true);
    setPaginationDetails((prev) => {
      return {
        ...prev,
        totalPost:
          backupTableData?.totalElements !== undefined &&
          backupTableData?.totalElements,
        totalPages:
          backupTableData?.totalPages !== undefined &&
          backupTableData?.totalPages,
        currentPage:
          backupTableData?.currentPage !== undefined
            ? backupTableData?.currentPage + 1
            : 1,
      };
    });
  };

  // const percentage = 66;

  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + (currentValue?.count || 0),
    initialValue
  );

  const bgColor = search.length > 0 ? "#FEC7B4" : "#848587";
  const setStatusDateHandler = (val) => {
    setSelectedStatus([]);
    setStatusDate(val);
    setFormDate(val);
    setToDate(increaseOneDate(val));
    setIsCalledSatausApi(true);
    setIsStatusFilter(true);
  };
  const handleUpdateUtrShow = (data) => {
    setShowUpdateUtronly(true);
    setShow(false);
    setDataForUpdateUtr(data);
  };
  const handleUpdateUtrClose = () => {
    setShowUpdateUtronly(false);
    setShow(false);
    setDataForUpdateUtr({});
  };
  return (
    <React.Fragment>
      {
        <>
          <Tooltip id="txn-tooltip" effect="solid" />
          <div className="mid">
            <div className="container-fluid">
              <div className="maincard">
                <div className="tab-content" id="mobiletab">
                  <div
                    className="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div style={{ marginTop: "0px" }} className="head">
                      <div className="search-filter-mobile-view">
                        <div
                          // style={{ marginTop: "20px" }}
                          id="search-filters"
                          className="dropdown fltr"
                        >
                          <button
                            type="button"
                            title="Filter"
                            className="filter dropdown-toggle"
                            id="fillist"
                            data-bs-boundary="viewport"
                            onClick={(e) => toggleDropdown(e)}
                            aria-expanded={isDropdownOpen}
                          >
                            Filter
                          </button>
                          <div
                            className={`dropdown-menu dropdown-menu-right ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            id="filterbox"
                            aria-labelledby="fillist"
                          >
                            <form onSubmit={applyStatus}>
                              <div className="col-12 col-md-12 mb-2 border-bottom ">
                                <div className="form-floating">
                                  <div className="formselect mb-2">
                                    <label>Selected Status</label>
                                    <Select
                                      className="basic-multi-select"
                                      styles={stylesofStype}
                                      closeMenuOnSelect={false}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={statusOption}
                                      onChange={changeHandler}
                                      value={selectedStatus}
                                      placeholder=" select multiple option"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                // style={{ borderBottom: "1px solid #dee2e6" }}
                                className="filters"
                              >
                                <label htmlFor="filterupdatedOn">
                                  Updated On
                                </label>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="filterupdatedOn"
                                    value={filterupdatedOn}
                                    checked={filterupdatedOn}
                                    onChange={(e) =>
                                      setFilterupdatedOn(e.target.checked)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="filters">
                                <label for="select-state">From Date:</label>
                                <input
                                  type="date"
                                  onChange={fromDateHandler}
                                  value={formDate}
                                />
                              </div>

                              <div className="filters">
                                <label for="select-state">To Date:</label>
                                <input
                                  min={formDate}
                                  type="date"
                                  onChange={toDateHandler}
                                  value={toDate}
                                />
                              </div>
                              <div className="filters">
                                <label htmlFor="select-state">
                                  From Amt Range:
                                </label>
                                <input
                                  style={{
                                    width: "100%",
                                    height: "34px",
                                    borderRadius: "3px",
                                    paddingLeft: "3px",
                                    border: "1px solid #dee2e6",
                                  }}
                                  type="text"
                                  onChange={fromAmountHandler}
                                  value={fromAmount}
                                />
                              </div>
                              <div className="filters amountrange">
                                <label htmlFor="select-state">
                                  To Amt Range:
                                </label>
                                <input
                                  style={{
                                    width: "100%",
                                    height: "34px",
                                    borderRadius: "3px",
                                    paddingLeft: "3px",
                                    border: "1px solid #dee2e6",
                                  }}
                                  //min={formDate}
                                  type="text"
                                  onChange={toAmountHandler}
                                  value={toAmount}
                                />
                              </div>

                              <div className="fbtn">
                                <button
                                  className="btn"
                                  type="submit"
                                  id="btnapply"
                                  disabled={checkDisable()}
                                >
                                  Apply
                                </button>
                                <button
                                  className="btn"
                                  type="reset"
                                  id="btnclear"
                                  style={{ backgroundColor: dangerColor }}
                                  onClick={resetApply}
                                >
                                  Clear
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <SearchBar
                          searched={searched}
                          searchdata={searchdata}
                          clearSearchData={clearSearchData}
                          bgColor={bgColor}
                          search={search}
                          searchedByItemShow={searchedByItemShow}
                          searchedBy={searchedBy}
                          setSearchTyping={setSearchTyping}
                          searchedByItem={searchedByItem}
                          setSearchedBy={setSearchedBy}
                          setSearchedByItemShow={setSearchedByItemShow}
                          searchTyping={searchTyping}
                        />
                      </div>

                      {/* </div> */}
                      <Addticket
                        tokenRequest={ticketRequest}
                        tokenChangeHandle={ticketChangeHandle}
                        handleFileChange={handleFileChange}
                        attachedFile={attachedFile}
                        createNewToken={createNewTicket}
                        attachmentId={attachmentId}
                        show={show}
                        handleClose={handleClose}
                        handleShow={handleShow}
                        selectedTraxn={selectedTraxn}
                        setShowTicketDropdown={setShowTicketDropdown}
                        showTicketDropdown={showTicketDropdown}
                        selectedTicket={selectedTicket}
                        setselectedTicket={setselectedTicket}
                        isAllTicketResolved={isAllTicketResolved}
                        setIsAllTicketResolved={setIsAllTicketResolved}
                        ticketLists={ticketLists}
                        setTicketLists={setTicketLists}
                        handleUpdateUtrShow={handleUpdateUtrShow}
                      />
                      <UpdateUtrAspaymentpage
                        type="PAY_IN"
                        tokenRequest={ticketRequest}
                        show={showUpdateUtrOnly}
                        handleClose={handleUpdateUtrClose}
                        handleShow={handleUpdateUtrShow}
                        dataForUpdateUtr={dataForUpdateUtr}
                        selectedTraxn={selectedTraxn}
                        setShowTicketDropdown={setShowTicketDropdown}
                        showTicketDropdown={showTicketDropdown}
                        selectedTicket={selectedTicket}
                        setselectedTicket={setselectedTicket}
                        isAllTicketResolved={isAllTicketResolved}
                        setIsAllTicketResolved={setIsAllTicketResolved}
                        ticketLists={ticketLists}
                        setTicketLists={setTicketLists}
                        headers={headers}
                        searchTyping={searchTyping}
                        handleUpdateUtrShow={handleUpdateUtrShow}
                        setDataForUpdateUtr={setDataForUpdateUtr}
                        reloadTxn={reloadTxn}
                        mid={mid}
                      />

                      <StatusDetails
                        transactionStatuswithAmount={
                          transactionStatuswithAmount
                        }
                        sumOfallSatus={sumOfallSatus}
                        setStatusDateHandler={setStatusDateHandler}
                        setStatusDate={setStatusDate}
                        statusDate={statusDate}
                        reloadTxn={reloadTxn}
                        statusFilterHandler={statusFilterHandler}
                      />
                    </div>
                    <div className="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data) => {
                              return (
                                <div className="txn-item" key={data.id}>
                                  <div className="txn-head" id="txnhead1">
                                    <div
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        className={`txncard ${
                                          data.status === "SUCCESS_AUTO" ||
                                          data.status === "SUCCESS_MANUAL" ||
                                          data.status ===
                                            "SUCCESS_INCOMPLETE" ||
                                          data.status === "SUCCESS_FROM_FAILED"
                                            ? "success grbg"
                                            : `${
                                                data.status ===
                                                  "PENDING_PAYMENT" ||
                                                data.status ===
                                                  "PAYMENT_PROCESSED" ||
                                                data.status === "ACCEPTED" ||
                                                data.status === "TIMEOUT"
                                                  ? "pending ylbg"
                                                  : "failed rdbg"
                                              }`
                                        }`}
                                      >
                                        <div className="row">
                                          <div className="col-12 col-md-2">
                                            <div className="txntxt">
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data?.createdOn !==
                                                    undefined &&
                                                    data?.createdOn !== null &&
                                                    data?.createdOn
                                                      .replace("T", " ")
                                                      .slice(0, -4)}{" "}
                                                </span>{" "}
                                                {/* ₹ {data.transaction.amount}{" "} */}
                                              </h6>
                                              <h6
                                                onClick={() =>
                                                  copyTextToClipboard(
                                                    data?.receivingVpa,
                                                    toast
                                                  )
                                                }
                                              >
                                                {data?.receivingVpa}{" "}
                                                <MdContentCopy
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />{" "}
                                              </h6>
                                            </div>
                                          </div>
                                          <div
                                            className={`col-12 ${
                                              (isSuperAdmin(id) &&
                                                selectedId == null) ||
                                              (isUserAdmin(id) &&
                                                selectedId == null)
                                                ? "col-md-3"
                                                : "col-md-3"
                                            }`}
                                          >
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.requestId,
                                                  toast
                                                )
                                              }
                                            >
                                              <h5>
                                                <h6>
                                                  ReqID: {data?.requestId}{" "}
                                                  <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  />
                                                </h6>
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                            <div
                                              className="txntxt"
                                              onClick={() =>
                                                copyTextToClipboard(
                                                  data?.id,
                                                  toast
                                                )
                                              }
                                            >
                                              <h5>
                                                <h6>
                                                  TxnID: {data?.id}{" "}
                                                  <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  />
                                                </h6>
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                          </div>

                                          <div
                                            // className="col-12 col-md-3"
                                            className="col-12 col-md-4"
                                          >
                                            <div className="txntxt">
                                              <h6
                                                onClick={() =>
                                                  copyTextToClipboard(
                                                    data?.utr,
                                                    toast
                                                  )
                                                }
                                              >
                                                <TooltipLite
                                                  content={
                                                    <div className="custom-tooltip-content">
                                                      UTR: {utrLeng(data?.utr)}{" "}
                                                      <br />
                                                      Usr UTR:{" "}
                                                      {utrLeng(
                                                        data?.userEnteredUtr
                                                      )}
                                                    </div>
                                                  }
                                                >
                                                  UTR: {utrLeng(data?.utr)}{" "}
                                                  <MdContentCopy
                                                    style={{
                                                      color: primaryColor,
                                                    }}
                                                  />
                                                </TooltipLite>
                                              </h6>
                                              <h6
                                                onClick={() =>
                                                  data?.additional
                                                    ?.FLOW_TYPE !== "DECIMAL"
                                                    ? copyTextToClipboard(
                                                        data?.orderCode,

                                                        toast
                                                      )
                                                    : undefined
                                                }
                                              >
                                                {data?.additional?.FLOW_TYPE ==
                                                "DECIMAL" ? (
                                                  `UNQ AMT: ${Number(
                                                    data?.uniqueAmount || 0
                                                  ).toFixed(2)}`
                                                ) : (
                                                  <>
                                                    OrdCode: {data?.orderCode}{" "}
                                                    <MdContentCopy
                                                      style={{
                                                        color: primaryColor,
                                                      }}
                                                    />
                                                  </>
                                                )}
                                              </h6>
                                              {/* <h6
                                                onClick={() =>
                                                  copyTextToClipboard(
                                                    data?.orderCode,
                                                    toast
                                                  )
                                                }
                                              >
                                                OrdCode: {data?.orderCode}{" "}
                                                <MdContentCopy
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h6> */}
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                            className="col-12 col-md-1"
                                          >
                                            {
                                              <div>
                                                <h4>
                                                  {checkstatus(
                                                    data?.status
                                                  ) && (
                                                    <RiCustomerService2Fill
                                                      onClick={(e) =>
                                                        selectedTranxtForIssue(
                                                          e,
                                                          data
                                                        )
                                                      }
                                                      size={25}
                                                      style={{
                                                        color: primaryColor,
                                                      }}
                                                    />
                                                  )}
                                                </h4>
                                              </div>
                                            }
                                            <div>
                                              <h4
                                                data-tooltip-id="txn-tooltip"
                                                data-tooltip-content={`Click For Call Back Request`}
                                              >
                                                <FcCallback
                                                  onClick={(e) =>
                                                    handleCallBack(e, data)
                                                  }
                                                  size={22}
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                  className={
                                                    iconLoader?.loader &&
                                                    iconLoader.id == data.id
                                                      ? "rotate-icon"
                                                      : ""
                                                  }
                                                />
                                              </h4>

                                              {/* )} */}
                                            </div>
                                          </div>
                                          <div className="col-12 col-md-2">
                                            <div className="txntxt">
                                              <h4>
                                                <TooltipLite
                                                  content={
                                                    <div className="custom-tooltip-content">
                                                      Amount:{" "}
                                                      {formatNumberForIndia(
                                                        data?.transaction
                                                          ?.amount
                                                      )}{" "}
                                                      <br />
                                                      Processed Amount:{" "}
                                                      {formatNumberForIndia(
                                                        data?.processedAmount
                                                      )}
                                                    </div>
                                                  }
                                                >
                                                  {isSuccess(data)
                                                    ? formatNumberForIndia(
                                                        data?.processedAmount
                                                      )
                                                    : formatNumberForIndia(
                                                        data?.transaction
                                                          ?.amount
                                                      )}
                                                  {/*formatNumberForIndia(
                                                    data?.transaction?.amount
                                                  )*/}
                                                </TooltipLite>
                                              </h4>

                                              <h4>
                                                {" "}
                                                <span
                                                  className={`${
                                                    data.status ===
                                                      "SUCCESS_AUTO" ||
                                                    data.status ===
                                                      "SUCCESS_MANUAL" ||
                                                    data.status ===
                                                      "SUCCESS_INCOMPLETE" ||
                                                    data.status ===
                                                      "SUCCESS_FROM_FAILED"
                                                      ? "success"
                                                      : `${
                                                          data.status ===
                                                            "PENDING_PAYMENT" ||
                                                          data.status ===
                                                            "PAYMENT_PROCESSED" ||
                                                          data.status ===
                                                            "ACCEPTED" ||
                                                          data.status ===
                                                            "TIMEOUT"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.status}
                                                </span>
                                              </h4>
                                              {/* )} */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div className="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 && (
                                <p>
                                  {paginationDetails.currentPage !==
                                    undefined &&
                                    paginationDetails.currentPage !== null &&
                                    paginationDetails.totalPost !== undefined &&
                                    paginationDetails.totalPost !== null &&
                                    table !== undefined &&
                                    Array.isArray(table) &&
                                    setpageContent(
                                      paginationDetails.currentPage - 1,
                                      table.length,
                                      paginationDetails.totalPost
                                    )}

                                  <button
                                    className={"lbbtn"}
                                    // disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export csv
                                  </button>
                                </p>
                              )}

                            {paginationDetails.totalPost !== undefined &&
                              paginationDetails.totalPost !== null &&
                              paginationDetails.totalPost > 10 && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={paginationDetails.currentPage}
                                  totalCount={paginationDetails.totalPost}
                                  pageSize={paginationDetails.postsPerPage}
                                  onPageChange={(page) => handalpageclick(page)}
                                />
                              )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </React.Fragment>
  );
};

export default UpiHome;
